import { DialogContent, Grid, Divider, Button, Dialog, IconButton } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { OPEN_BACKDROP, DESTROY_BACKDROP } from "../../../../containers/actions/types";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, CircularProgress } from "@material-ui/core";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@material-ui/lab";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import moment from "moment";
import axios from 'axios';
import { appUrl } from '../../../../../../utils/config';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import EditIcon from '@material-ui/icons/Edit';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { presentFormatedData } from "../../functionalComponents/dataFormatFunctions";
import StructuredInformationFiles from "./updateBatch/StructuredInformation/StructuredInformationFiles";
import StructuredInformation from "./updateBatch/StructuredInformation/StructuredInformation";
import ProductDetailsLoader from "./ProductDetailsLoader";
import EditPlannedAllocatedQuantityDialog from '../../PurchaseOrderDashbaordIndex/POColumns/EditPlannedAllocatedQuantityDialog';
import AllocatePOsModal from '../../PurchaseOrderDashbaordIndex/AllocatePOsModal';
import StyledDialog from '../../../../../../components/common/models/Dialog';

const useStyles = makeStyles((theme) => ({
  timelineContainer: {
    padding: 0, // Remove padding
    margin: 0, // Remove margin
  },
  timeline: {
    paddingLeft: 0, // Remove padding to eliminate left space
  },
  timelineItem: {
    "&.MuiTimelineItem-missingOppositeContent:before": {
      display: "none", // This removes the default ::before content
    },
  },
  timelineDot: {
    backgroundColor: "#1391C9",
    width: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontSize: "1.2rem",
    fontWeight: "bold",
    fontFamily: "Inter",
  },
  timelineDotText: {
    fontFamily: theme.typography.fontFamily,
  },
  timelineContentBox: {
    padding: theme.spacing(1),
    // border: '1px solid #ddd',
    borderRadius: "8px",
    // backgroundColor: '#f9f9f9',
    marginBottom: theme.spacing(4),
  },
  stepTitle: {
    fontWeight: "600",
    fontSize: "20px",
  },
  separator: {
    backgroundColor: "#1391C9",
    width: "4px",
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  root: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    // width: '100%',
    // backgroundColor: '#EDEDED',
    "& .MuiStepLabel-label": {
      color: "rgba(0, 0, 0, 0.87)",
      fontWeight: 500,
    },
  },
  table: {
    minWidth: 650,
  },
  tableContainer: {
    boxShadow: "none", // Remove border and shadow from the container
    // marginBottom: '3rem',
  },
  tableCell: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    // width: '16.666%', // Set equal width for each cell
    padding: "16px", // Standard padding for consistency
  },
  tableCell2: {
    textAlign: "left",
    backgroundColor: "#E5F2F7",
    borderBottom: "none", // Remove bottom border
    // width: '16.666%', // Set equal width for each cell
    padding: "16px", // Standard padding for consistency
    paddingTop: "0px",
  },
  headerCell: {
    fontWeight: "bold",
  },
  editIconButton: {
    "&.Mui-disabled": {
      "& svg": {
        color: "#ec6535 !important",
        opacity: 0.4,
      },
    },
  },
}));

const ViewStructuredInformation = (props) => {
  // BCM-898: `extraActions` is an optional node OR a function of the open
  // document's type (Sync Inventory / Sync PO / Resubmit Document) supplied by
  // the Goods Receipt dashboard and forwarded down, unresolved, to the two-pane
  // digitalization view — CommonDigitizedDocument is what actually calls it with
  // its own docType. Undefined elsewhere.
  // `onRefreshParent` (optional, Goods Receipt) — called once the batch has changed
  // here (a document's review/edits saved, allocation or consumption updated) so
  // the caller can refresh its own copy of the batch.
  const { batchDetails, cmoBatchNumber, consumptionSameAsAllocation, extraActions, onRefreshParent } = props;
  //console.log("consumptionSameAsAllocation",props.consumptionSameAsAllocation  )
  const classes = useStyles();
  const dispatch = useDispatch();
  const [digitizedExtractedData, setDigitizedExtractedData] = useState([]);
  const [loadingDigitizedData, setLoadingDigitizedData] = useState(false);
  const [digitizedDataError, setDigitizedDataError] = useState(null);

  const [showConsumptionDialog, setShowConsumptionDialog] = useState(false);
  const [allocationData, setAllocationData] = useState([]);
  const [allocationLoading, setAllocationLoading] = useState(false);
  const [allocationError, setAllocationError] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedRowForEdit, setSelectedRowForEdit] = useState(null);
  const [allocationRes, setAllocationRes] = useState({});
  const [poLineRes, setPoLineRes] = useState({});
  const [actionForConsumption, setActionForConsumption] = useState(false);
  const [consumptionUpdateLoading, setConsumptionUpdateLoading] = useState(false);
  const [consumptionUpdateSuccess, setConsumptionUpdateSuccess] = useState(false);
  const [componentAllocationSuccess, setComponentAllocationSuccess] = useState(false);
  const [depleteInstructionComponents, setDepleteInstructionComponents] = useState([]);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  // Goods Receipt only (extraActions is undefined everywhere else this
  // component is rendered) — Upload Allocation on the consumption/allocation
  // table, restricted to this batch's PO via AllocatePOsModal's
  // singlePOAllocation/poNumber props, same as PA3ReviewConsumption.jsx.
  const [uploadAllocationOpen, setUploadAllocationOpen] = useState(false);

  // Same flag gates both the pencil (per-row, below) and the Upload Allocation
  // button — hoisted here (it's a batch-level flag, not per-row) so both
  // controls always agree and stay in sync with each other.
  const canEdit = batchDetails?.reviewAllocationForConsumptionReqd === true;

  const showConsumptionStep = (consumptionSameAsAllocation ?? batchDetails?.consumptionSameAsAllocation) === true;
  const { existingCOAFiles, existingCustomFiles, existingEInvoiceFiles, existingEWayBillFiles, customFilesList } = batchDetails;

  // Raw IDoc-sourced files (e.g. Production ASN / Post Shipment ASN) are rendered as a
  // grouped step whose "Download Document" list already surfaces their sibling PDFs
  // (Certificate of Analysis, Certificate of Manufacture, Consumption Details, etc. —
  // see downloadFiles in renderDocumentItem). Those siblings must not also appear as
  // their own separate timeline step below.
  const isXmlFile = (f) => /\.xml$/i.test(f?.customFileName || "");

  const allFiles = [
    ...(existingCOAFiles?.length ? existingCOAFiles : []),
    ...(existingCustomFiles?.length ? existingCustomFiles : []),
    ...(existingEInvoiceFiles?.length ? existingEInvoiceFiles : []),
    ...(existingEWayBillFiles?.length ? existingEWayBillFiles : []),
    ...(customFilesList?.length ? customFilesList : []),
  ];


  // Preserve original file types for backward compatibility
  // const fileTypeOrder = [
  //   "BMR",
  //   "COC",
  //   "dsbatch_coa",
  //   "packingList",
  //   "PackingList",
  //   "proformaInvoice",
  //   "eInvoice",
  //   "CommercialInvoice",
  //   "DeliveryNote",
  //   "ConfirmationOfPartialManufacturingOfAnMedicinalProduct",
  //   "FinishedProductDispatchCheckList",
  //   // New digitized document types
  //   "ConsumptionDetails",
  //   "BillOfLading",
  //   "PackingSlip",
  //   "CertificateOfAnalysis",
  //   "CertificateOfManufacture"
  // ];

  // const sortedFiles = allFiles?.sort((a, b) => {
  //   return fileTypeOrder.indexOf(a.customFileType) - fileTypeOrder.indexOf(b.customFileType);
  // });

  // const getLatestFiles = (files) => {
  //   const fileMap = new Map();

  //   files.forEach(file => {
  //     const key = `${file.customFileType}-${file.customFileName}`;
  //     const existing = fileMap.get(key);

  //     if (!existing || new Date(file.lastUpdatedDate) > new Date(existing.lastUpdatedDate)) {
  //       fileMap.set(key, file);
  //     }
  //   });

  //   return Array.from(fileMap.values());
  // };


  // // Process existing files (preserve original logic)
  // const doubleSortedFiles = getLatestFiles(
  //   sortedFiles.filter(file => file?.customFileType !== "custom")
  // );

  useEffect(() => {
    const extractDigitizedDataFromBatchDetails = () => {
      try {
        setLoadingDigitizedData(true);
        setDigitizedDataError(null);

        const extractedDocuments = [];

        // Create a map of digitized extracted data for matching structured data
        const digitizedDataMap = new Map();
        if (batchDetails.digitizedExtractedData && Array.isArray(batchDetails.digitizedExtractedData)) {
          batchDetails.digitizedExtractedData.forEach(item => {
            const documentType = item.kvpJsonOriginal?.document_type;
            if (documentType) {
              digitizedDataMap.set(documentType, item);
            }
          });
        }

        // Process documents from customFilesList
        if (batchDetails.customFilesList && Array.isArray(batchDetails.customFilesList)) {
          batchDetails.customFilesList.forEach(doc => {
            // Find matching structured data from digitizedExtractedData
            const structuredData = digitizedDataMap.get(doc.customFileType);
            
            // Create kvpJson from the structured data
            let kvpJson = null;
            if (structuredData && structuredData.kvpJsonOriginal) {
              kvpJson = JSON.stringify(structuredData.kvpJsonOriginal);
            }

            // Transform the document to match the expected structure
            const transformedDoc = {
              documentType: doc.customFileType,
              processedFileName: doc.customFileName,
              schrockenCustomFileID: doc.schrockenCustomFileID,
              emailReceivedTimestamp: doc.lastUpdatedDate,
              status: 'completed',
              customFileHash: doc.customFileHash,
              customFileDescription: doc.customFileDescription,
              markedForDelete: doc.markedForDelete,
              kvpJson: kvpJson,
              originalDigitizedData: structuredData // Keep reference to original structured data
            };
            extractedDocuments.push(transformedDoc);
          });
        }

        // Sort by lastUpdatedDate in ascending order
        extractedDocuments.sort((a, b) => {
          const dateA = new Date(a.emailReceivedTimestamp);
          const dateB = new Date(b.emailReceivedTimestamp);
          return dateA - dateB;
        });

        setDigitizedExtractedData(extractedDocuments);
        
        
      } catch (error) {
        console.error('Error extracting digitized data from batch details:', error);
        setDigitizedDataError(error.message);
        setDigitizedExtractedData([]);
      } finally {
        setLoadingDigitizedData(false);
      }
    };

    if (batchDetails) {
      extractDigitizedDataFromBatchDetails();
    }
  }, [batchDetails]);

  const fetchAllocationData = async () => {
    const batchID = batchDetails?.schrockenDeliveryScheduleBatchID;
    const batchSize = batchDetails?.batchSize;
    if (!batchID || !batchSize) return null;
    setAllocationLoading(true);
    setAllocationError(null);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActualNewDirect/${batchID}/${batchSize}`;
      const res = await axios.get(url);
      if (res.data?.status) {
        const list = res.data.data?.length > 0 ? res.data.data : [];
        setAllocationData(list);
        setAllocationRes(res.data);

        // Compute deplete instruction components
        const depleteComponents = [];
        list.forEach((component) => {
          const lots = component?.plannedLotNumberAllocationDetails || [];
          const depleteLots = lots.filter(lot => lot?.isDepletedBatch === true);
          if (depleteLots.length > 0) {
            const batches = depleteLots.map(lot => lot?.lotNumber).filter(Boolean);
            if (batches.length > 0) {
              depleteComponents.push({
                componentCode: component?.componentCode,
                componentName: component?.componentName,
                batches,
              });
            }
          }
        });
        setDepleteInstructionComponents(depleteComponents);

        return list;
      } else {
        setAllocationData([]);
        setAllocationError('Failed to load allocation data');
        return null;
      }
    } catch (err) {
      console.error('Error fetching allocation data:', err);
      setAllocationError('Error loading allocation data');
      return null;
    } finally {
      setAllocationLoading(false);
    }
  };

  const fetchPoLineData = async () => {
    const schrockenSLID = batchDetails?.schrockenSLID;
    if (!schrockenSLID) return;
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLineNewDirect/${schrockenSLID}`;
      const res = await axios.get(url);
      if (res.data?.status) {
        setPoLineRes(res.data.data);
      }
    } catch (err) {
      console.error('Error fetching PO line data:', err);
    }
  };

  const handlePencilClick = (row) => {
    setActionForConsumption(false);
    const list = poLineRes?.componentAllocationDataList || [];
    const match = list.find(
      c => c?.componentAllocationDetails?.componentCode === row.componentCode
    ) || list[0] || null;
    setSelectedRowForEdit(match);
    setEditDialogOpen(true);
  };

  const handleUpdateConsumption = async () => {
    setConsumptionUpdateLoading(true);
    dispatch({ type: OPEN_BACKDROP, payload: 'Please wait' });
    try {
      const BOMConsumptionDetails = allocationData.map(component => ({
        BomComponentCode: component.componentCode,
        bomComponentCodeCMO: component.componentCode,
        BomComponentName: component.componentName,
        BomComponentRefUOM: component.uom,
        bomComponentRefUOMCMO: component.uom,
        consumptionBatchNumbers: (component.plannedLotNumberAllocationDetails || []).map(lot => ({
          componentBatchNumber: lot.lotNumber,
          componentBatchNumberCMO: lot.lotNumber,
          BomComponentConsumedQuantity: lot.plannedAllocatedQuantity,
          bomComponentConsumedQuantityCMO: lot.plannedAllocatedQuantity,
        })),
      }));
      const payload = {
        vendorMosymphonyID: batchDetails?.vendorMosymphonyID,
        BOMConsumptionDataList: [{
          scheduleAgreementNumber: batchDetails?.scheduleAgreementNumber || '',
          schrockenSLID: batchDetails?.schrockenSLID,
          schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
          BOMConsumptionDetails,
        }],
      };
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateBOMConsumedQty`;
      const res = await axios.post(url, payload);
      if (res.data?.status) {
        setConsumptionUpdateSuccess(true);
        setActionForConsumption(false);
        if (onRefreshParent) onRefreshParent();
      }
    } catch (err) {
      console.error('Error updating consumption:', err);
    } finally {
      setConsumptionUpdateLoading(false);
      dispatch({ type: DESTROY_BACKDROP });
    }
  };

  // Improved filtering logic - process only digitized documents from customFilesList
  // const existingFileTypes = new Set(doubleSortedFiles.map(file => file.customFileType));
  
  // Helper function to match digitized data: first by document_type, then by schrockenCustomFileID
  const findMatchingDigitizedData = (file) => {
    if (!Array.isArray(batchDetails.digitizedExtractedData)) return null;
    
    // Step 1: Find all items matching document_type
    const typeMatches = batchDetails.digitizedExtractedData.filter(
      item => item.kvpJsonOriginal?.document_type === file.customFileType
    );
    
    if (typeMatches.length === 0) return null;
    
    // Step 2: Check if any match by schrockenCustomFileID (exact match)
    const idMatch = typeMatches.find(
      item => item.schrockenCustomFileID === file.schrockenCustomFileID || 
              item.schrockenCustomFileID?.toString() === file.schrockenCustomFileID?.toString()
    );
    
    // Return exact ID match if found, otherwise null (we only want exact matches)
    return idMatch || null;
  };

  // Process digitized documents with improved logic
  // Process all files from allFiles
const digitizedDocuments = allFiles
  .map(file => {
    // Find matching structured data using helper function (exact match by document_type AND schrockenCustomFileID)
    const structuredData = findMatchingDigitizedData(file);
    
    // Check if it's an exact match (by ID)
    const isExactMatch = structuredData !== null;

    // Create kvpJson from the structured data
    let kvpJson = null;
    if (structuredData && structuredData.kvpJsonOriginal) {
      kvpJson = JSON.stringify(structuredData.kvpJsonOriginal);
    }

    return {
      documentType: file.customFileType,
      processedFileName: file.customFileName,
      schrockenCustomFileID: file.schrockenCustomFileID,
      emailReceivedTimestamp: file.lastUpdatedDate,
      status: 'completed',
      customFileHash: file.customFileHash,
      customFileDescription: file.customFileDescription,
      markedForDelete: file.markedForDelete,
      kvpJson: kvpJson,
      originalDigitizedData: structuredData,
      customFileType: file.customFileType,
      customFileName: file.customFileName,
      lastUpdatedDate: file.lastUpdatedDate,
      isDigitized: !!structuredData, // Mark as digitized if structured data exists
      isExactMatch: isExactMatch, // Track if it's an exact match by schrockenCustomFileID
      isDuplicate: file.isDuplicate || false // Default to false if isDuplicate is undefined
    };
  })
  .filter(doc => doc.processedFileName && doc.processedFileName !== '');

  // Direct schrockenCustomFileID -> deliveryNumber lookup, independent of
  // findMatchingDigitizedData's stricter matching (which requires document_type to match
  // kvpJsonOriginal specifically and can miss a legitimately new upload). A file's delivery
  // number only depends on its OWN digitizedExtractedData entry existing by ID — nothing
  // else needs to match for the grouping fix below to correctly isolate it.
  const deliveryNumberByFileID = new Map(
    (Array.isArray(batchDetails?.digitizedExtractedData) ? batchDetails.digitizedExtractedData : [])
      .filter((d) => d?.deliveryNumber)
      .map((d) => [String(d.schrockenCustomFileID), d.deliveryNumber])
  );

  // Post Shipment ASN XML filenames always embed their own delivery number as the 4th
  // underscore-separated segment (e.g. "DELVRY03_45438955_CYKYK_0080068089_....xml") — a
  // deterministic signal that's always available immediately on upload, unlike the
  // digitizedExtractedData link above which depends on digitization having completed and
  // successfully carried the deliveryNumber through. Used as a fallback below whenever the
  // digitization-based lookup comes up empty, so an old/orphaned ASN upload still resolves
  // to its real shipment instead of landing in an unmatched group of its own. The regex
  // itself is the type gate — it only ever matches this one IDoc naming convention, so it's
  // safe to run against every document without an explicit customFileType check.
  const extractDeliveryNumberFromAsnFilename = (customFileName) => {
    const match = /^DELVRY03_[^_]+_[^_]+_(\d+)_/.exec(customFileName || "");
    return match ? match[1] : null;
  };

  const resolveDeliveryNumber = (doc) =>
    deliveryNumberByFileID.get(String(doc.schrockenCustomFileID)) ||
    extractDeliveryNumberFromAsnFilename(doc.customFileName);

  // Enhanced sorting logic: Returns both latest and replaced documents with proper matching
  const getOptimallyOrderedFiles = (documents) => {
    // Define the category order
    const categoryOrder = {
      'Post-Manufacturing': 1,
      'Pre-Shipment Documents': 2,
      'Post-Shipment Documents': 3
    };

    // Step 1: Group documents by type and track first occurrence
    const documentGroups = new Map();
    const firstOccurrence = new Map();

    // A batch can have more than one concurrent shipment — each with its own Post Shipment
    // ASN and Bill of Lading, tagged with its own unique deliveryNumber. Grouping by
    // customFileType alone would treat every shipment's document of the same type as a
    // "replacement" of the others, which is wrong for that case — only a genuine re-upload
    // for the SAME delivery number is a real replacement.
    //
    // But splitting the grouping key by deliveryNumber on a PER-FILE basis (does this one
    // file happen to have a deliveryNumber linked?) misfires for the far more common case:
    // a single shipment's document re-uploaded (Batch Reset resubmission, or a retried IDoc),
    // where the OLDER upload often hasn't been linked to its deliveryNumber yet (digitization
    // lag/failure) while the newer one has. That made the old and new uploads land in two
    // DIFFERENT groups, so both survived as "latest" and both showed up in the main section's
    // download list together instead of the old one correctly falling into Replaced Documents.
    //
    // Fix: only split by deliveryNumber when 2+ DISTINCT delivery numbers are actually
    // observed for that customFileType — i.e. there's real evidence of multiple concurrent
    // shipments. With 0 or 1 distinct value observed (the single-shipment case, regardless of
    // which specific files happen to have the link), every file of that type groups together
    // as before/after versions of the same document, exactly like types with no deliveryNumber
    // at all (Certificate of Analysis, Consumption Details, etc.) already do.
   
    const categoriesWithIdoc = new Set(
      documents.filter(isXmlFile).map((d) => d.documentCategoryType).filter(Boolean)
    );

    const deliveryNumbersByType = new Map();
    documents.forEach((doc) => {
      if (!categoriesWithIdoc.has(doc.documentCategoryType)) return;
      const dn = resolveDeliveryNumber(doc);
      if (!dn) return;
      if (!deliveryNumbersByType.has(doc.customFileType)) {
        deliveryNumbersByType.set(doc.customFileType, new Set());
      }
      deliveryNumbersByType.get(doc.customFileType).add(dn);
    });

    // For a type where multiple real shipments are now confirmed, a document that still has
    // no resolvable delivery number of its own (a Bill of Lading PDF, say — these don't embed
    // a delivery number in their filename the way ASN XML files do, and digitization may not
    // have linked one yet) would otherwise land in its own isolated, single-member group,
    // outside every real shipment's group — so it would never even be COMPARED by timestamp
    // against the file that actually supersedes it (the latest/replaced split a few lines
    // below only compares documents already placed in the same group). Infer its shipment
    // from timing instead: attach it to whichever known delivery number's documents were
    // uploaded closest in time to it — e.g. a Bill of Lading uploaded 1 second after a given
    // shipment's ASN is almost certainly that same shipment's paperwork.
    const knownDeliveryEvents = documents
      .map((doc) => {
        const dn = resolveDeliveryNumber(doc);
        if (!dn) return null;
        const date = new Date(doc.lastUpdatedDate || doc.emailReceivedTimestamp);
        return Number.isNaN(date.getTime()) ? null : { date, deliveryNumber: dn };
      })
      .filter(Boolean);

    const inferDeliveryNumberByProximity = (doc) => {
      const docDate = new Date(doc.lastUpdatedDate || doc.emailReceivedTimestamp);
      if (Number.isNaN(docDate.getTime()) || knownDeliveryEvents.length === 0) return null;
      let closestDeliveryNumber = null;
      let closestDiff = Infinity;
      knownDeliveryEvents.forEach((event) => {
        const diff = Math.abs(docDate.getTime() - event.date.getTime());
        if (diff < closestDiff) {
          closestDiff = diff;
          closestDeliveryNumber = event.deliveryNumber;
        }
      });
      return closestDeliveryNumber;
    };

    documents.forEach(doc => {
      const distinctDeliveryNumbers = deliveryNumbersByType.get(doc.customFileType);
      const hasMultipleShipments = distinctDeliveryNumbers && distinctDeliveryNumbers.size > 1;
      const deliveryNumber = hasMultipleShipments
        ? (resolveDeliveryNumber(doc) || inferDeliveryNumberByProximity(doc))
        : null;
      const docType = deliveryNumber ? `${doc.customFileType}::${deliveryNumber}` : doc.customFileType;
      const docDate = new Date(doc.lastUpdatedDate || doc.emailReceivedTimestamp);
      
      // Track the first occurrence of each document type
      if (!firstOccurrence.has(docType)) {
        firstOccurrence.set(docType, docDate);
      } else {
        const existingFirstDate = firstOccurrence.get(docType);
        if (docDate < existingFirstDate) {
          firstOccurrence.set(docType, docDate);
        }
      }

      // Group documents by type
      if (!documentGroups.has(docType)) {
        documentGroups.set(docType, []);
      }
      documentGroups.get(docType).push(doc);
    });

    // Step 2: For each group, get the latest and replaced documents
    const latestDocuments = [];
    const replacedDocuments = [];
    
    documentGroups.forEach((docs, docType) => {
      // Sort documents in this group by date (latest first)
      const sortedDocs = docs.sort((a, b) => {
        const dateA = new Date(a.lastUpdatedDate || a.emailReceivedTimestamp);
        const dateB = new Date(b.lastUpdatedDate || b.emailReceivedTimestamp);
        return dateB - dateA; // Descending order: latest first
      });
      
      if (sortedDocs.length === 0) return;
      
      // Get category from the original file data
      const originalFile = allFiles.find(f => f.schrockenCustomFileID === sortedDocs[0].schrockenCustomFileID);
      const documentCategoryType = originalFile?.documentCategoryType || '';
      
      const latestDoc = sortedDocs[0];
      const latestHasMatch = latestDoc.isExactMatch === true;
      
      // Add latest document to main section
      latestDocuments.push({
        ...latestDoc,
        firstOccurrenceDate: firstOccurrence.get(docType),
        documentCategoryType: documentCategoryType
      });
      
      // Handle Replaced Documents section
      if (sortedDocs.length > 1) {
        // Get remaining documents (excluding the latest one)
        const remainingDocs = sortedDocs.slice(1);
        
        // Group remaining documents by customFileHash
        const hashGroups = new Map();
        remainingDocs.forEach(doc => {
          const fileHash = doc.customFileHash || 'no-hash';
          if (!hashGroups.has(fileHash)) {
            hashGroups.set(fileHash, []);
          }
          hashGroups.get(fileHash).push(doc);
        });
        
        if (!latestHasMatch) {
          // Case 1: Latest has NO match
          // For each hash group, check for matches first, then show last updated
          hashGroups.forEach((docsInHashGroup, fileHash) => {
            // Sort by date (latest first) within hash group
            const sortedByHash = docsInHashGroup.sort((a, b) => {
              const dateA = new Date(a.lastUpdatedDate || a.emailReceivedTimestamp);
              const dateB = new Date(b.lastUpdatedDate || b.emailReceivedTimestamp);
              return dateB - dateA;
            });
            
            // First check if any document in this hash group has a match
            let matchedDoc = null;
            for (let i = 0; i < sortedByHash.length; i++) {
              if (sortedByHash[i].isExactMatch === true) {
                matchedDoc = sortedByHash[i];
                break; // Found match, use it
              }
            }
            
            // If match found, show matched document with Download + Review
            // If no match, show last updated document from this hash group with only Download
            const docToShow = matchedDoc || sortedByHash[0];
            const docFile = allFiles.find(f => f.schrockenCustomFileID === docToShow.schrockenCustomFileID);
            const docCategoryType = docFile?.documentCategoryType || documentCategoryType;
            
            // If no match found, remove digitized data to show only Download
            const finalDoc = matchedDoc ? {
              ...docToShow,
              firstOccurrenceDate: firstOccurrence.get(docType),
              documentCategoryType: docCategoryType
            } : {
              ...docToShow,
              originalDigitizedData: null,
              isDigitized: false,
              isExactMatch: false, // Force no match to show only Download
              firstOccurrenceDate: firstOccurrence.get(docType),
              documentCategoryType: docCategoryType
            };
            
            replacedDocuments.push(finalDoc);
          });
        } else {
          // Case 2: Latest HAS match
          // For each hash group, show last updated document with only Download
          hashGroups.forEach((docsInHashGroup, fileHash) => {
            // Sort by date (latest first) within hash group
            const sortedByHash = docsInHashGroup.sort((a, b) => {
              const dateA = new Date(a.lastUpdatedDate || a.emailReceivedTimestamp);
              const dateB = new Date(b.lastUpdatedDate || b.emailReceivedTimestamp);
              return dateB - dateA;
            });
            
            // Show last updated document from this hash group with only Download
            const lastUpdatedDoc = sortedByHash[0];
            const docFile = allFiles.find(f => f.schrockenCustomFileID === lastUpdatedDoc.schrockenCustomFileID);
            const docCategoryType = docFile?.documentCategoryType || documentCategoryType;
            
            // Remove digitized data to show only Download
            const docWithoutDigitized = {
              ...lastUpdatedDoc,
              originalDigitizedData: null,
              isDigitized: false,
              isExactMatch: false, // Force no match to show only Download
              firstOccurrenceDate: firstOccurrence.get(docType),
              documentCategoryType: docCategoryType
            };
            
            replacedDocuments.push(docWithoutDigitized);
          });
        }
      }
    });

    // Step 3: Sort by category order first, then by first occurrence date within each category
    const sortFunction = (a, b) => {
      const categoryA = categoryOrder[a.documentCategoryType] || 999;
      const categoryB = categoryOrder[b.documentCategoryType] || 999;
      
      // First sort by category
      if (categoryA !== categoryB) {
        return categoryA - categoryB;
      }
      
      // Within same category, sort by first occurrence date (earliest first)
      return a.firstOccurrenceDate - b.firstOccurrenceDate;
    };

    return {
      latest: latestDocuments.sort(sortFunction),
      replaced: replacedDocuments.sort(sortFunction)
    };
  };

  const { latest: finalSortedFiles, replaced: replacedDocuments } = getOptimallyOrderedFiles(digitizedDocuments);

  // Document categories that already have a grouped step (an XML-sourced entry, e.g.
  // Production ASN / Post Shipment ASN) whose Download Document list covers their
  // sibling PDFs. Those siblings are dropped from the standalone step list below so
  // each document appears in exactly one place — grouped under its category step.
  const groupedDocumentCategories = new Set(
    finalSortedFiles.filter(isXmlFile).map((f) => f.documentCategoryType).filter(Boolean)
  );

  // A batch with multiple concurrent shipments carries one XML entry (Post Shipment ASN /
  // Production ASN) per shipment, each sharing the same documentCategoryType but tagged
  // with its own deliveryNumber (see getOptimallyOrderedFiles above). Left as-is, every one
  // of those became its own timeline step, so "Post-Shipment Documents" appeared twice
  // (once per shipment) instead of once with a shipment tab inside — collapse them here to
  // a single representative entry per category. CommonDigitizedDocument already discovers
  // every shipment sharing that document_type from batchDetails.digitizedExtractedData on
  // its own and renders them as tabs within the one step, so no shipment's data is dropped
  // by only keeping one here.
  //
  // Preference order: an XML upload that never got linked to its own digitizedExtractedData
  // entry (e.g. a retried/duplicate IDoc whose processing failed) has isExactMatch === false
  // and carries zero review data of its own. Picking earliest-by-date alone can pick that
  // empty upload over a later one that DID digitize successfully — which then wires the
  // whole step's "Review Digitalized Document" panel to null (digitizedData) and silently
  // hides the real ASN's data (CommonDigitizedDocument's own shipment-tab discovery never
  // even fires, since it requires digitizedData.documentType). So prefer a matched entry
  // over an unmatched one first, and only fall back to earliest-by-date as a tiebreaker
  // among equally-matched entries, to keep selection stable across renders.
  const representativeXmlFileByCategory = new Map();
  finalSortedFiles.filter(isXmlFile).forEach((f) => {
    const existing = representativeXmlFileByCategory.get(f.documentCategoryType);
    if (!existing) {
      representativeXmlFileByCategory.set(f.documentCategoryType, f);
      return;
    }
    const currentHasData = f.isExactMatch === true;
    const existingHasData = existing.isExactMatch === true;
    if (currentHasData && !existingHasData) {
      representativeXmlFileByCategory.set(f.documentCategoryType, f);
    } else if (currentHasData === existingHasData && f.firstOccurrenceDate < existing.firstOccurrenceDate) {
      representativeXmlFileByCategory.set(f.documentCategoryType, f);
    }
  });

  const timelineFiles = finalSortedFiles.filter((f) =>
    isXmlFile(f)
      ? representativeXmlFileByCategory.get(f.documentCategoryType) === f
      : !groupedDocumentCategories.has(f.documentCategoryType)
  );

  // Helper function to get document display info
  const getDocumentDisplayInfo = (file) => {
    let documentCategory = "File";
    let updatedFileName = 'File';
    let updatedDigitizedName = 'File';
    
    // Helper function to get base document type (removes _Digitized suffix)
    const getBaseDocumentType = (fileType) => {
      return fileType?.replace('_Digitized', '') || fileType;
    };
    
    const baseFileType = getBaseDocumentType(file?.customFileType);
    
    switch (baseFileType) {
      case "BMR":
        documentCategory = "Consumption Pages";
        updatedFileName = 'Consumption Pages.PDF';
        updatedDigitizedName = 'Digitized Consumption Details';
        break;
      case "COC":
        documentCategory = "COC";
        updatedFileName = 'Certificate of Conformance.PDF';
        updatedDigitizedName = 'Digitized CoC';
        break;
      case "dsbatch_coa":
        documentCategory = "COA";
        updatedFileName = 'Certificate of Analysis.PDF';
        updatedDigitizedName = 'Digitized CoA';
        break;
      case "eInvoice":
        documentCategory = "Invoice";
        updatedFileName = 'Invoice.PDF';
        updatedDigitizedName = 'Digitized Invoice';
        break;
      case "packingList":
      case "PackingList":
        documentCategory = "Packing List";
        updatedFileName = 'Packing List.PDF';
        updatedDigitizedName = 'Digitized Packing List';
        break;
      case "proformaInvoice":
        documentCategory = "Proforma Invoice";
        updatedFileName = 'Proforma Invoice.PDF';
        updatedDigitizedName = 'Digitized Proforma Invoice';
        break;
      // New digitized document types
      case "ConsumptionDetails":
        documentCategory = "Consumption Details";
        updatedFileName = 'Consumption Details.PDF';
        updatedDigitizedName = 'Digitized Consumption Details';
        break;
      case "BillOfLading":
        documentCategory = "Bill of Lading";
        updatedFileName = 'Bill of Lading.PDF';
        updatedDigitizedName = 'Digitized Bill of Lading';
        break;
      case "PackingSlip":
        documentCategory = "Packing Slip";
        updatedFileName = 'Packing Slip.PDF';
        updatedDigitizedName = 'Digitized Packing Slip';
        break;
      case "CertificateOfAnalysis":
        documentCategory = "Certificate of Analysis";
        updatedFileName = 'Certificate of Analysis.PDF';
        updatedDigitizedName = 'Digitized Certificate of Analysis';
        break;
      case "CertificateOfManufacture":
        documentCategory = "Certificate of Manufacture";
        updatedFileName = 'Certificate of Manufacture.PDF';
        updatedDigitizedName = 'Digitized Certificate of Manufacture';
        break;
      case "CommercialInvoice":
        documentCategory = "Commercial Invoice";
        updatedFileName = 'Commercial Invoice.PDF';
        updatedDigitizedName = 'Digitized Commercial Invoice';
        break;
      case "DeliveryNote":
        documentCategory = "Delivery Note";
        updatedFileName = 'Delivery Note.PDF';
        updatedDigitizedName = 'Digitized Delivery Note';
        break;
      case "ConfirmationOfPartialManufacturingOfAnMedicinalProduct":
        documentCategory = "Partial Manufacturing Confirmation";
        updatedFileName = 'Partial Manufacturing Confirmation.PDF';
        updatedDigitizedName = 'Digitized Partial Manufacturing Confirmation';
        break;
      case "FinishedProductDispatchCheckList":
        documentCategory = "Finished Product Dispatch Check List";
        updatedFileName = 'Finished Product Dispatch Check List.PDF';
        updatedDigitizedName = 'Digitized Finished Product Dispatch Check List';
        break;
      case "Production ASN":
        documentCategory = "Post-Manufacturing Documents";
        updatedFileName = 'Production ASN.PDF';
        updatedDigitizedName = 'Digitized Post-Manufacturing Documents';
        break;
      case "Post Shipment ASN":
        documentCategory = "Post-Shipment Documents";
        updatedFileName = 'Post Shipment ASN.PDF';
        updatedDigitizedName = 'Digitized Post-Shipment Documents';
        break;
      default:
        // Handle unknown document types - use the document type as the category
        if (file?.isDigitized && file?.originalDigitizedData?.documentType) {
          const originalType = file.originalDigitizedData.documentType;
          
          // Create human-readable names from document types
          documentCategory = originalType
            .replace(/([A-Z])/g, ' $1') // Add space before capital letters
            .trim() // Remove leading space
            .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
          
          // Force 'of' to lowercase wherever it appears
          const fixOf = (text) => text ? text.replace(/\bOf\b/g, 'of') : text;

          documentCategory = fixOf(documentCategory);
          updatedFileName = `${documentCategory}.PDF`;
          updatedDigitizedName = `Digitalized ${documentCategory}`;
        } else {
          // Apply the same humanize + 'of' lowercasing to baseFileType
          documentCategory = (baseFileType || "File")
            .replace(/([A-Z])/g, ' $1')
            .trim()
            .replace(/^./, str => str.toUpperCase());

          const fixOf = (text) => text ? text.replace(/\bOf\b/g, 'of') : text;

          documentCategory = fixOf(documentCategory);
          updatedFileName = `${documentCategory}.PDF`;
          updatedDigitizedName = `Digitalized ${documentCategory}`;
        }
        break;
    }
    
    return { documentCategory, updatedFileName, updatedDigitizedName };
  };

  // In the Replaced Documents section, a non-XML sibling (e.g. Bill of Lading,
  // Consumption Details) should be labeled by its overarching category — matching how
  // the main list already groups everything under the Production ASN / Post Shipment ASN
  // step — rather than its own specific document type name. Keyed by the raw backend
  // documentCategoryType (see categoryOrder above for the same raw values).
  const REPLACED_DOCUMENT_CATEGORY_LABELS = {
    'Post-Manufacturing': 'Post-Manufacturing Documents',
    'Pre-Shipment Documents': 'Pre-Shipment Documents',
    'Post-Shipment Documents': 'Post-Shipment Documents',
  };

  // A single Batch Reset resubmission can replace several documents that all share the
  // same overarching category (e.g. Certificate of Manufacture, Consumption Details and
  // Certificate of Analysis all live under "Post-Manufacturing") WHEN they're genuinely
  // siblings of a common IDoc (Production ASN / Post Shipment ASN) — that's the only reason
  // they'd otherwise render as separate "Post-Manufacturing Documents" sections instead of
  // one grouped step, mirroring how the main timeline collapses that same IDoc's siblings
  // (see groupedDocumentCategories/representativeXmlFileByCategory above).
  //
  // A Non-ERP CMO batch carries no IDoc at all for a category (no Production ASN / Post
  // Shipment ASN in customFilesList) — there, two unrelated document types that merely
  // happen to share a raw documentCategoryType (e.g. Delivery Note and Finished Product
  // Dispatch Check List both tagged "Post-Shipment Documents") are NOT siblings of anything
  // and must not be merged: each has its own independent digitization/review status, and
  // merging them left only one of the two with a "Review Digitalized Document" link — the
  // other's review option silently disappeared since only one file can be "the
  // representative" of a merged group. Gating the merge on groupedDocumentCategories (the
  // same "does an IDoc actually exist for this category" check the main section already
  // uses) keeps the grouped behavior for genuine IDoc siblings while leaving every other
  // category's documents — including Packing Slip, Commercial Invoice, and this Non-ERP CMO
  // case — in their own individual Replaced Documents section, unchanged.
  const groupedReplacedDocuments = [];
  const replacedGroupIndexByCategory = new Map();
  replacedDocuments.forEach((file) => {
    const groupLabel = REPLACED_DOCUMENT_CATEGORY_LABELS[file?.documentCategoryType];
    const shouldMerge = groupLabel && groupedDocumentCategories.has(file.documentCategoryType);
    if (!shouldMerge) {
      groupedReplacedDocuments.push({ representative: file, files: [file] });
      return;
    }
    if (replacedGroupIndexByCategory.has(file.documentCategoryType)) {
      const group = groupedReplacedDocuments[replacedGroupIndexByCategory.get(file.documentCategoryType)];
      group.files.push(file);
      // Prefer a real (non-XML) document as the representative so the "Review Digitalized
      // Document" panel reflects an actual reviewable document rather than the raw IDoc/XML
      // glue file (e.g. a stale resubmitted Production ASN), which carries no meaningful
      // review data of its own.
      if (isXmlFile(group.representative) && !isXmlFile(file)) {
        group.representative = file;
      }
    } else {
      replacedGroupIndexByCategory.set(file.documentCategoryType, groupedReplacedDocuments.length);
      groupedReplacedDocuments.push({ representative: file, files: [file] });
    }
  });

  // Helper function to render a document item
  const renderDocumentItem = (file, index, totalCount, isReplaced = false, stepOffset = 0, downloadFilesOverride = null) => {
    const { documentCategory: ownDocumentCategory, updatedFileName, updatedDigitizedName } = getDocumentDisplayInfo(file);
    // The generic "Post-Shipment Documents"/"Post-Manufacturing Documents" label only makes
    // sense when this document is genuinely a sibling of a real IDoc (Production ASN / Post
    // Shipment ASN) in this batch — the same groupedDocumentCategories check the merge above
    // uses. A Non-ERP CMO batch has no IDoc at all, so its documents (Delivery Note, Finished
    // Product Dispatch Check List, etc.) must keep showing their own specific type name here,
    // not get relabeled with a category that doesn't apply to them.
    const documentCategory = (isReplaced
      && groupedDocumentCategories.has(file?.documentCategoryType)
      && REPLACED_DOCUMENT_CATEGORY_LABELS[file?.documentCategoryType])
      || ownDocumentCategory;
    // Only show digitized data if it's an exact match (by schrockenCustomFileID)
    const showDigitizedData = file.isExactMatch === true;

    // Raw IDoc-sourced files (e.g. the Production ASN / Post Shipment ASN XML) have no
    // business value as a user-facing download themselves — instead offer the other real
    // documents filed under the same documentCategoryType (e.g. Production ASN's sibling
    // Certificate of Manufacture / Certificate of Analysis / Consumption Details).
    //
    // Sourced from finalSortedFiles (the already-deduped "latest per document type" list
    // from getOptimallyOrderedFiles) rather than the raw allFiles — allFiles still contains
    // superseded/replaced files whenever the backend doesn't flip markedForDelete on the old
    // row during a resubmission, which was leaking old + newly resubmitted siblings into
    // this same download list together.
    const downloadFiles = downloadFilesOverride
      // Same rule as every other branch here: a raw IDoc/XML file (e.g. a superseded Post
      // Shipment ASN sitting in this group alongside a real superseded Bill of Lading) has no
      // business value as a user-facing download — exclude it so Replaced Documents only ever
      // lists real, downloadable files, never the ASN glue file itself.
      ? downloadFilesOverride
          .filter((f) => !isXmlFile(f))
          .map((f) => ({ ...f, displayFileName: getDocumentDisplayInfo(f).updatedFileName }))
      : !file
      ? []
      : !isXmlFile(file)
      ? [file]
      : file.documentCategoryType
      ? finalSortedFiles
          .filter(
            (f) =>
              f.documentCategoryType === file.documentCategoryType &&
              f.schrockenCustomFileID !== file.schrockenCustomFileID &&
              !f.markedForDelete &&
              !isXmlFile(f)
          )
          // Each sibling needs its OWN display name here (e.g. "Certificate of Manufacture.PDF"),
          // not the current step's updatedFileName — otherwise every row in a multi-sibling
          // list would incorrectly show the same label.
          .map((f) => ({ ...f, displayFileName: getDocumentDisplayInfo(f).updatedFileName }))
      : [];

    return (
      <TimelineItem key={`${isReplaced ? 'replaced-' : ''}${index}`} className={classes.timelineItem}>
        <TimelineSeparator>
          <TimelineDot className={classes.timelineDot}>
            <span className={classes.timelineDotText}>{index + 1 + stepOffset}</span>
          </TimelineDot>
          {index !== totalCount - 1 &&
            <TimelineConnector className={classes.separator} />
          }
        </TimelineSeparator>
        <TimelineContent>
          <Box className={classes.timelineContentBox}>
            <Typography className={classes.stepTitle}>{documentCategory}</Typography>
            <StructuredInformation
              coa={true}
              extraActions={extraActions}
              onRefreshParent={onRefreshParent}
              batchDetails={batchDetails}
              cmoBatchNumber={cmoBatchNumber}
              structuredFiles={file}
              downloadFiles={downloadFiles}
              updatedFileName={updatedFileName}
              updatedDigitizedName={updatedDigitizedName}
              documentCategory={documentCategory}
              digitizedData={showDigitizedData ? file : null}
              isDuplicateDigitized={file.isDuplicate}
              poNumber={batchDetails?.scheduleAgreementNumber}
              batchNumber={batchDetails?.vendorBatchNumber}
              {...(updatedDigitizedName === 'Digitized Consumption Details' && { consumption: true })}
            />
          </Box>
        </TimelineContent>
      </TimelineItem>
    );
  };

  return (
    <React.Fragment>
      <DialogContent>
        {/* <Grid
          container
          justifyContent="flex-start"
          style={{ backgroundColor: "#c2e1ef" }}
        > */}
          {/* <Grid item>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      PO Number
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Product Code / Description
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Plant ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Storage Location ID
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      CMO
                    </TableCell>
                    <TableCell
                      className={`${classes.tableCell} ${classes.headerCell}`}
                    >
                      Batch Number
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        batchDetails?.scheduleAgreementNumber || ""
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        `${batchDetails?.fgMaterialCode} / ${batchDetails?.fgMaterialName}` ||
                        "NA"
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(batchDetails?.vendorPlant || "")}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        batchDetails?.storageLocation || ""
                      )}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(batchDetails?.cmoMember || "")}
                    </TableCell>
                    <TableCell className={classes.tableCell2}>
                      {presentFormatedData(
                        batchDetails?.vendorBatchNumber || ""
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>  */}

           {/* Add ProductDetailsLoader component */}
        {/* {batchDetails?.collabrixProductID && ( */}
          <Grid style={{ marginTop: '1rem', marginBottom: '2rem' }}>
            <ProductDetailsLoader 
              collabrixProductID={batchDetails.collabrixProductID}
              poNumber={batchDetails?.scheduleAgreementNumber}
              materialPlantID={batchDetails?.vendorPlant}
              materialStorageLocationID={batchDetails?.storageLocation}
              batchNumber={batchDetails?.vendorBatchNumber}
              vendorMosymphonyID={batchDetails?.vendorMosymphonyID}
              vendorPlantID={batchDetails?.vendorPlant}
              sponsorStorageLocation={batchDetails?.storageLocation}
            />
          </Grid>
        {/* )} */}
        {/* </Grid> */}
      
        <Grid style={{ marginTop: '3rem' }}>
          {loadingDigitizedData && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <CircularProgress />
              <Typography style={{ marginTop: '1rem' }}>Processing digitized documents...</Typography>
            </div>
          )}
          
          {digitizedDataError && (
            <div style={{ textAlign: 'center', padding: '1rem', backgroundColor: '#ffebee', borderRadius: '4px', marginBottom: '1rem' }}>
              <Typography color="error" variant="body2">
                Warning: Could not process digitized documents ({digitizedDataError})
              </Typography>
            </div>
          )}
          
          {digitizedDocuments.length === 0 && !loadingDigitizedData && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <Typography>No digitized documents found.</Typography>
            </div>
          )}
          
          {/* Consumption Details Step — shown when consumptionSameAsAllocation and reviewAllocationForConsumptionReqd are both true */}
          {showConsumptionStep && (
            <TimelineItem className={classes.timelineItem}>
              <TimelineSeparator>
                <TimelineDot className={classes.timelineDot}>
                  <span className={classes.timelineDotText}>1</span>
                </TimelineDot>
                {timelineFiles.length > 0 && (
                  <TimelineConnector className={classes.separator} />
                )}
              </TimelineSeparator>
              <TimelineContent>
                <Box className={classes.timelineContentBox}>
                  <Typography className={classes.stepTitle}>Consumption Details</Typography>
                  <Typography variant="body2" style={{ margin: '0.5rem 0 1rem', color: '#000', fontWeight: 600, fontSize: '0.95rem' }}>
                    View/Edit Consumption Details
                  </Typography>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: '#E65100', color: '#fff', textTransform: 'none', borderRadius: '24px', padding: '0.5rem 1.5rem', boxShadow: 'none' }}
                    onClick={() => { fetchAllocationData(); fetchPoLineData(); setShowConsumptionDialog(true); }}
                  >
                    View/Edit Consumption (same as allocation) Details
                  </Button>
                </Box>
              </TimelineContent>
            </TimelineItem>
          )}

          {/* Main Documents Section */}
          {timelineFiles.map((file, index) => renderDocumentItem(file, index, timelineFiles.length, false, showConsumptionStep ? 1 : 0))}
          
          {/* Replaced Documents Section */}
          {groupedReplacedDocuments.length > 0 && (
            <>
              <Grid style={{ marginTop: '3rem', marginBottom: '1rem' }}>
                {/* Top horizontal line with gap above */}
                <Divider style={{ marginTop: '1rem', marginBottom: '1rem' }} />
                {/* Replaced Documents title */}
                <Typography variant="h6" style={{ fontWeight: 600, color: '#000', marginBottom: '0.3rem' }}>
                  Replaced Documents
                </Typography>
                {/* Small line under title (like other sections) with gap below */}
                <span style={{
                  border: '2px solid #707070',
                  display: 'block',
                  width: '1.6rem',
                  backgroundColor: '#707070',
                  marginBottom: '1.5rem'
                }}></span>
              </Grid>
              {groupedReplacedDocuments.map((group, index) =>
                renderDocumentItem(
                  group.representative,
                  index,
                  groupedReplacedDocuments.length,
                  true,
                  0,
                  // Raw IDoc/XML entries (e.g. a stale resubmitted Production ASN) have no
                  // business value as a user-facing download themselves — same rule already
                  // applied to the main section's downloadFiles above.
                  group.files.filter((f) => !isXmlFile(f))
                )
              )}
            </>
          )}
        </Grid>
      </DialogContent>

      {/* Consumption Details Full-Screen Dialog */}
      <Dialog
        open={showConsumptionDialog}
        onClose={() => setShowConsumptionDialog(false)}
        fullScreen
      >
        {/* Header with Back button */}
        <div style={{ display: 'flex', alignItems: 'center', padding: '0.75rem 1.5rem', borderBottom: '1px solid #e0e0e0' }}>
          <Button
            startIcon={<ChevronLeftIcon />}
            onClick={() => setShowConsumptionDialog(false)}
            style={{ textTransform: 'none', color: '#000', fontWeight: 500, marginRight: '1rem', padding: 0, minWidth: 'auto' ,fontSize:15}}
          >
            Back
          </Button>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            View/Edit Consumption (same as allocation) Details
          </Typography>
        </div>

        <DialogContent style={{ padding: '1.5rem' }}>
          {/* Batch header */}
          <ProductDetailsLoader
            collabrixProductID={batchDetails?.collabrixProductID}
            poNumber={batchDetails?.scheduleAgreementNumber}
            materialPlantID={batchDetails?.vendorPlant}
            materialStorageLocationID={batchDetails?.storageLocation}
            batchNumber={batchDetails?.vendorBatchNumber}
            vendorMosymphonyID={batchDetails?.vendorMosymphonyID}
            vendorPlantID={batchDetails?.vendorPlant}
            sponsorStorageLocation={batchDetails?.storageLocation}
          />

          {/* Allocation table */}
          <div style={{ marginTop: '1.5rem' }}>
            {allocationLoading ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>
                <CircularProgress />
              </div>
            ) : allocationError ? (
              <Typography color="error" style={{ padding: '1rem' }}>{allocationError}</Typography>
            ) : (
              <TableContainer component={Paper} style={{ border: '1px solid #ccc', borderRadius: '8px', overflow: 'auto', maxWidth: '100%' }}>
                <Table stickyHeader className="default-table-styles">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>BMS Material Code / Description</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="right">Material BoM Qty.</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>UOM</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>BMS Material Batch Number</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }} align="right">Net Available Qty.</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Expiry Date</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', borderRight: '2px solid rgba(224, 224, 224, 1)' }} align="right">Planned Allocated Qty.</TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                        Planned Material Batch Number
                        <IconButton size="small" onClick={() => setInfoDialogOpen(true)} style={{ marginLeft: '4px', padding: '4px' }}>
                          <InfoOutlinedIcon style={{ fontSize: '18px', color: '#666' }} />
                        </IconButton>
                      </TableCell>
                      <TableCell style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>Country of Origin</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allocationData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">No allocation data found</TableCell>
                      </TableRow>
                    ) : allocationData.map((row, rowIdx) => {
                      const hasPlanned = row.plannedLotNumberAllocationDetails?.length > 0;
                      const lots = hasPlanned
                        ? row.plannedLotNumberAllocationDetails
                        : (row.actualConsumptionDetails?.length > 0
                            ? row.actualConsumptionDetails.map(c => ({
                                lotNumber: c.componentBatchNumber,
                                netAvailableQuantity: c.netAvailableQuantity,
                                expiryDate: c.expiryDate,
                                plannedAllocatedQuantity: 0,
                                plannedLotAllocation: null,
                                countryOfOrigin: null,
                                _fromActual: true,
                              }))
                            : [{}]);
                      return lots.map((lot, lotIdx) => {
                        const cellKey = `${rowIdx}-${lotIdx}`;
                        // canEdit is hoisted to component scope above (a batch-level flag, not per-row).
                        return (
                          <TableRow key={cellKey} style={{ backgroundColor: rowIdx % 2 === 0 ? '#fff' : '#fafafa' }}>
                            {lotIdx === 0 && (
                              <>
                                <TableCell rowSpan={lots.length}>
                                  {row.componentCode && row.componentName
                                    ? `${row.componentCode} / ${row.componentName}`
                                    : ''}
                                </TableCell>
                                <TableCell rowSpan={lots.length} align="right">
                                  {row.componentQuantity != null ? Number(row.componentQuantity).toFixed(3) : ''}
                                </TableCell>
                                <TableCell rowSpan={lots.length}>{row.uom || ''}</TableCell>
                              </>
                            )}
                            <TableCell>{lot.lotNumber || ''}</TableCell>
                            <TableCell align="right">
                              {lot.netAvailableQuantity != null ? Number(lot.netAvailableQuantity).toLocaleString() : ''}
                            </TableCell>
                            <TableCell>
                              {lot.expiryDate ? moment(lot.expiryDate).format('DD-MMM-YYYY').toUpperCase() : ''}
                            </TableCell>
                            <TableCell align="right" style={{ borderRight: '2px solid rgba(224, 224, 224, 1)' }}>
                              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                {(() => {
                                  if (lot.plannedAllocatedQuantity == null) return '';
                                  const numericValue = Number(lot.plannedAllocatedQuantity);
                                  return isNaN(numericValue) ? lot.plannedAllocatedQuantity : numericValue.toFixed(3);
                                })()}
                                <IconButton
                                  size="small"
                                  onClick={() => handlePencilClick(row)}
                                  style={{ color: '#E65100', padding: '2px' }}
                                  className={classes.editIconButton}
                                  disabled={!canEdit}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </TableCell>
                            {lotIdx === 0 && (() => {
                              const poLineComponent = (poLineRes?.componentAllocationDataList || []).find(
                                c => c?.componentAllocationDetails?.componentCode === row.componentCode
                              );
                              return (
                                <>
                                  <TableCell rowSpan={lots.length}>
                                    {poLineComponent?.componentAllocationDetails?.plannedLotNumbers || ''}
                                  </TableCell>
                                  <TableCell rowSpan={lots.length}>
                                    {poLineComponent?.componentAllocationDetails?.countryOfOrigin || ''}
                                  </TableCell>
                                </>
                              );
                            })()}
                          </TableRow>
                        );
                      });
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </div>

          {/* Upload Allocation — shown here regardless of how this screen was
              reached (Goods Receipt or the legacy Batch Execution dashboard).
              Reuses the same AllocatePOsModal as PA3ReviewConsumption.jsx; the
              singlePOAllocation/poNumber restriction is applied ONLY when
              extraActions is present (Goods Receipt) — see the modal below. */}
          <Box mt={2}>
            <Button
              variant="outlined"
              disabled={!canEdit}
              style={{
                borderRadius: 999,
                textTransform: 'none',
                padding: '6px 24px',
                fontWeight: 600,
                // Whitened/greyed when disabled — same intent as the pencil's
                // Mui-disabled dimming, so both controls read as disabled
                // together rather than the button still looking clickable.
                borderColor: canEdit ? '#1B2430' : '#D0D5DD',
                color: canEdit ? '#1B2430' : '#B9C4D1',
              }}
              onClick={() => setUploadAllocationOpen(true)}
            >
              Upload Allocation
            </Button>
          </Box>

          {/* Deplete Instruction Note */}
          {depleteInstructionComponents.length > 0 && (
            <div style={{
              marginTop: '1rem',
              padding: '0.75rem 1rem',
              border: '1px solid black',
              borderRadius: '4px',
              fontSize: '0.875rem',
            }}>
              <Typography variant="body2">
                Instruction - Deplete allocated batch(es) for BMS Material Code(s){' '}
                {depleteInstructionComponents.map((component, compIndex) => (
                  <span key={compIndex}>
                    {component.componentCode}
                    {component.batches.length > 0 && (
                      <span>
                        {' '}({component.batches.map((batch, batchIndex) => (
                          <span key={batchIndex}>
                            Batch {batch}{batchIndex < component.batches.length - 1 ? ', ' : ''}
                          </span>
                        ))})
                      </span>
                    )}
                    {compIndex < depleteInstructionComponents.length - 1 ? ', ' : ''}
                  </span>
                ))}
              </Typography>
            </div>
          )}

        </DialogContent>

        {/* Info Dialog for Planned Material Batch Number */}
        <Dialog open={infoDialogOpen} onClose={() => setInfoDialogOpen(false)} maxWidth="xs" fullWidth>
          <DialogContent style={{ padding: '24px' }}>
            <Grid container justifyContent="flex-end">
              <Typography
                variant="body2"
                style={{ fontSize: '1rem', fontWeight: 600, display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                onClick={() => setInfoDialogOpen(false)}
              >
                Close <CloseIcon fontSize="large" style={{ color: '#FF0000' }} />
              </Typography>
            </Grid>
            <Grid container direction="column" alignItems="center" style={{ marginTop: '16px' }}>
              <Typography variant="h6" style={{ fontWeight: 600, marginBottom: '20px' }}>
                Planned Material Batch Number
              </Typography>
              <Typography variant="body2" style={{ textAlign: 'center', lineHeight: '1.6' }}>
                Please use this field is to enter Material Batch Number
                <br /> that is not yet present in the inventory. In case of multiple
                <br /> Batch Number entry, use comma to separate the values.
              </Typography>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Upload Allocation — button above shows regardless of context, but
            singlePOAllocation/poNumber (restricting the upload to this
            batch's PO) are sent ONLY when reached via Goods Receipt
            (extraActions present). Via the legacy Batch Execution dashboard
            (extraActions undefined), neither field is sent — the upload keeps
            its existing "every PO in the file" behaviour there, exactly like
            the PO Collaboration dashboard's own AllocatePOsModal usage.
            On a genuine upload success, chain into the SAME flow the pencil-
            edit path uses (handleClose's success branch below): refresh the
            allocation table, then "Component allocation updated successfully"
            -> "Continue to update consumption details" -> handleUpdateConsumption
            -> "Consumption details updated successfully". */}
        <AllocatePOsModal
          open={uploadAllocationOpen}
          {...(extraActions
            ? { singlePOAllocation: true, poNumber: batchDetails?.scheduleAgreementNumber }
            : {})}
          onClose={() => setUploadAllocationOpen(false)}
          onUploadSuccess={async () => {
            setUploadAllocationOpen(false);
            if (onRefreshParent) onRefreshParent();
            await fetchAllocationData();
            setComponentAllocationSuccess(true);
          }}
        />

        {/* Edit allocation popup */}
        <Dialog open={editDialogOpen} maxWidth="lg" fullWidth>
          {selectedRowForEdit && (
            <EditPlannedAllocatedQuantityDialog
              lotData={selectedRowForEdit}
              lotAllocationData={poLineRes?.componentAllocationDataList || []}
              lotAllocationRes={poLineRes}
              rmPmCode={selectedRowForEdit?.componentAllocationDetails?.componentCode}
              onClose={() => setEditDialogOpen(false)}
              poData={{
                scheduleLineDetails: {
                  scheduleAgreementNumber: batchDetails?.scheduleAgreementNumber,
                  sponsorName: batchDetails?.sponsorOrgName,
                  vendorName: batchDetails?.cmoMember,
                  vendorPlant: batchDetails?.vendorPlant,
                  storageLocation: batchDetails?.storageLocation,
                  schrockenSLID: batchDetails?.schrockenSLID,
                  vendorMosymphonyID: batchDetails?.vendorMosymphonyID,
                },
              }}
              schrockenSLID={batchDetails?.schrockenSLID}
              vendorMosymphonyID={batchDetails?.vendorMosymphonyID}
              handleClose={async (type) => {
                setEditDialogOpen(false);
                if (type === 'success') {
                  if (onRefreshParent) onRefreshParent();
                  await fetchAllocationData();
                  setComponentAllocationSuccess(true);
                }
              }}
            />
          )}
        </Dialog>

        {/* Consumption details updated successfully */}
        <Dialog open={consumptionUpdateSuccess} fullWidth maxWidth="sm" PaperProps={{ style: { borderRadius: '16px' } }}>
          <DialogContent style={{ padding: '3.5rem 4rem', textAlign: 'center' }}>
            <CheckCircleIcon style={{ fontSize: '6rem', color: '#39811D', marginTop: '0.5rem' }} />
            <Typography variant="h5" style={{ fontWeight: 700, fontSize: '1.8rem', marginTop: '1.5rem', lineHeight: 1.3 }}>
              Consumption details updated successfully
            </Typography>
            <div style={{ marginTop: '2rem' }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#E65100',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '2rem',
                  padding: '0.6rem 3rem',
                  fontSize: '1rem',
                  boxShadow: 'none',
                }}
                onClick={() => {
                  setConsumptionUpdateSuccess(false);
                  fetchAllocationData();
                }}
              >
                OK
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Component allocation updated successfully */}
        <Dialog open={componentAllocationSuccess} fullWidth maxWidth="sm" PaperProps={{ style: { borderRadius: '16px' } }}>
          <DialogContent style={{ padding: '3.5rem 4rem', textAlign: 'center' }}>
            <CheckCircleIcon style={{ fontSize: '6rem', color: '#39811D', marginTop: '0.5rem' }} />
            <Typography variant="h5" style={{ fontWeight: 700, fontSize: '1.8rem', marginTop: '1.5rem', lineHeight: 1.3 }}>
              Component allocation updated successfully
            </Typography>
            <div style={{ marginTop: '2rem' }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#E65100',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: '2rem',
                  padding: '0.6rem 3rem',
                  fontSize: '1rem',
                  boxShadow: 'none',
                }}
                onClick={() => {
                  setComponentAllocationSuccess(false);
                  handleUpdateConsumption();
                }}
              >
                Continue to update consumption details
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </Dialog>
    </React.Fragment>
  );
};

export default ViewStructuredInformation;
